import type { CreateShiftParams, UpdateShiftParams } from 'types/shifts';

export const buildCreateShiftRequestPayload = (params: CreateShiftParams): Partial<Omit<CreateShiftParams, 'waiterId'>> => {
  const payload: Partial<Omit<CreateShiftParams, 'waiterId'>> = {
    start_kind: params.start_kind,
    end_kind: params.end_kind
  };

  if (params.start_kind === 'exact') payload.start_at = params.start_at;
  if (params.end_kind === 'exact') payload.end_at = params.end_at;
  if (params.table_ids !== undefined) payload.table_ids = params.table_ids;
  if (params.table_shortcut_ids !== undefined) payload.table_shortcut_ids = params.table_shortcut_ids;
  if (params.status) payload.status = params.status;
  if (params.restaurant_id) payload.restaurant_id = params.restaurant_id;
  if (params.date) payload.date = params.date;
  if (params.note !== undefined) payload.note = params.note;

  return payload;
};

export const buildUpdateShiftRequestPayload = (params: UpdateShiftParams): Partial<Omit<UpdateShiftParams, 'shiftId'>> => {
  const payload: Partial<Omit<UpdateShiftParams, 'shiftId'>> = {
    ...(params.start_kind && { start_kind: params.start_kind }),
    ...(params.end_kind && { end_kind: params.end_kind })
  };

  if (params.start_at && params.start_kind === 'exact') payload.start_at = params.start_at;
  if (params.end_at && params.end_kind === 'exact') payload.end_at = params.end_at;
  if (params.restaurant_id) payload.restaurant_id = params.restaurant_id;
  if (params.date) payload.date = params.date;
  if (params.status) payload.status = params.status;
  if (params.table_ids !== undefined) payload.table_ids = params.table_ids;
  if (params.table_shortcut_ids !== undefined) payload.table_shortcut_ids = params.table_shortcut_ids;
  if (params.note !== undefined) payload.note = params.note;

  return payload;
};
